import type { ReactNode } from 'react'
import { PublicHeader, PublicFooter } from './AppShell'

interface AuthLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
}

/**
 * Chrome for unauthenticated single-card screens (signup, password
 * reset, verified, update-password). Shares the public CTDCommons
 * header + footer with `LoginPage`, which uses the same chrome
 * directly so it can render its own two-column landing layout.
 *
 * The narrow card is preserved for these focused, form-only flows —
 * the login page is the only unauthenticated surface that doubles as
 * the SEO landing page.
 */
export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicHeader />
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl px-8 py-8 shadow-sm">
          <h1 className="text-xl font-semibold text-brand-charcoal mb-1">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm text-slate-500 mb-6">{subtitle}</p>
          ) : (
            <div className="mb-6" />
          )}
          {children}
        </div>
      </main>
      <PublicFooter />
    </div>
  )
}
